<template>
  <div>
    <Header />
    <Breadcrumbs title="My Unibud Bag" :value="webTotalLines[0] ? webTotalLines[0].value_show : ''" />
    <section class="cart-section section-b-space pb-0">
      <div v-if="pending_delivery === 1"  class="delivery_status"><router-link :to="{ path: '/delivery_map'}">Delivery In Progress</router-link></div>



      <template v-if="special_banner_url">
        <div v-if="special_banner_text" class="special_banner"><a style="color:white;" v-bind:href=special_banner_url target="_blank" @click="href_click_log('cart_banner')">{{special_banner_text}}</a></div>
      </template>
      <template v-else>
        <div v-if="special_banner_text" class="special_banner">{{special_banner_text}}</div>
      </template>


      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-sm-12 col-xs-12 px-0">
            <div class="my-cart-table" v-if="cart.length">
              <table class="table cart-table cart-list-table table-responsive-xs" v-for="(item,index) in cart" :key="index">
              <!--
                <thead>
                  <tr class="table-head">
                    <th scope="col">image</th>
                    <th scope="col">product name</th>
                    <th scope="col">price</th>
                    <th scope="col">quantity</th>
                    <th scope="col">discount code</th>
                    <th scope="col">discount</th>
                    <th scope="col">total</th>
                    <th scope="col">action</th>
                  </tr>
                </thead>
              -->
                <tbody>


                <tr>

                  <template v-if="item.isrewarditem === 0">

                      <td class="cart_img_td">
                        <router-link :to="{ path: '/product/sidebar/'+item.product_id_db}">
                          <img class="cart_img_size"
                            :src='item.image_url_small'
                          />
                        </router-link>
                      </td>
                      <td>
                        <div class="d-flex align-items-center justify-content-between">
                          <div class="cart_mobile_desc">
                            <h5>{{item.desc}}</h5>
                            <p class="cart-price">{{item.single_price_show_incl_tax}}</p>
                          </div>
                          <div class="d-flex align-items-center">
                            <a href="#" @click='removeCartItem(item)' class="remove_item">
                              <i class="ti-close"></i>
                            </a>
                            <div class="carts-box mobile-carts-box">
                              <div class="input-group">
                                <span class="input-group-prepend">
                                  <button
                                    type="button"
                                    class="btn quantity-left-minus"
                                    data-type="minus"
                                    data-field
                                    @click="increment(item)"
                                  >
                                    <i class="ti-angle-up"></i>
                                  </button>
                                </span>
                                <input
                                  type="text"
                                  name="quantity"
                                  class="form-control input-number"
                                  v-model="item.qty"
                                  @change="editqty(item)"
                                />
                                <span class="input-group-prepend">
                                  <button
                                    type="button"
                                    class="btn quantity-right-plus"
                                    data-type="plus"
                                    data-field
                                    @click="decrement(item)"
                                  >
                                    <i class="ti-angle-down"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          <!--
                            <div class="mobile-cart-content row" style="float: right;">
                              <a href="#" @click='removeCartItem(item)' style="width: 100%;">
                                <i class="fa fa-trash-o" style="margin-top:2px;transform: scale(1.4);" aria-hidden="true"></i>
                              </a>
                            </div>
                          -->
                          </div>
                        </div>
                        <!--
                        <div class="mobile-cart-content row">
                          <div class="row" style="width:100%;text-align:left;font-size:14px;">
                            <div class="col-6">Qty : {{item.qty}}</div>
                            <div class="col-6" style="text-align: right;">{{ item.single_price_show_incl_tax }}</div>
                          </div>

                          <div class="row" style="width:100%;text-align:left;font-size:14px;">
                            <div class="col-8">Discount Code :</div>
                            <div class="col-4" style="text-align:right;height:unset;">{{item.discount_code}}</div>
                          </div>
                          <div class="row" style="width:100%;text-align:left;font-size:14px;">
                            <div class="col-6">Discount:</div>
                            <div class="col-6" style="text-align: right;">{{item.discount_qty_amount_show_incl_tax}} Off</div>
                          </div>
                        </div>
                        -->
                      </td>
                      <td>
                        <h2>{{item.single_price_show_incl_tax}}</h2>
                      </td>
                      <td>
                        <div class="carts-box">
                          <div class="input-group">
                            <span class="input-group-prepend">
                              <button
                                type="button"
                                class="btn quantity-left-minus"
                                data-type="minus"
                                data-field
                                @click="decrement(item)"
                              >
                                <i class="ti-minus"></i>
                              </button>
                            </span>
                            <input
                              type="text"
                              name="quantity"
                              class="form-control input-number"
                              v-model="item.qty"
                              @change="editqty(item)"
                            />
                            <span class="input-group-prepend">
                              <button
                                type="button"
                                class="btn quantity-right-plus"
                                data-type="plus"
                                data-field
                                @click="increment(item)"
                              >
                                <i class="ti-plus"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <h2>{{item.discount_code}}</h2>
                      </td>
                      <td>
                        <h2>{{item.discount_qty_amount_show_incl_tax}}</h2>
                      </td>
                      <td>
                        <h2 class="td-color"
                        >{{ item.discounted_qty_price_show_incl_tax }}</h2>
                      </td>
  <!--                    <td>-->
  <!--                      <a class="icon" @click="removeCartItem(item)">-->
  <!--                        <i class="fa fa-trash-o" style="margin-top:2px;transform: scale(1.4);"></i>-->
  <!--                      </a>-->
  <!--                    </td>-->

                    </template>


                    <template v-if="item.isrewarditem === 1">

                      <td class="cart_img_td">
                        <router-link :to="{ path: ''}">
                          <img class="cart_img_size"
                              :src='item.image_url_small'
                              :alt="item.desc"
                          />
                        </router-link>
                      </td>
                      <td style="padding-left: 10px;">
                        <div class="row">
                          <div class="cart_mobile_desc">
                            <h5>{{item.desc}}</h5>
                          </div>
                          <div style="padding-left:0;">
    <!--                        <div class="mobile-cart-content row" style="float: right;">-->
    <!--                          <a href="#" @click='removeCartItem(item)' style="width: 100%;">-->
    <!--                            <i class="fa fa-trash-o" style="margin-top:2px;transform: scale(1.4);" aria-hidden="true"></i>-->
    <!--                          </a>-->
    <!--                        </div>-->
                          </div>
                        </div>
                        <div class="mobile-cart-content row">
    <!--                      <div class="row" style="width:100%;text-align:left;font-size:14px;">-->
    <!--                        <div class="col-6">Qty : {{item.qty}}</div>-->
    <!--                        <div class="col-6" style="text-align: right;">{{ item.single_price_show_inlc_tax }}</div>-->
    <!--                      </div>-->
    <!--                      <div class="row" style="width:100%;text-align:left;font-size:14px;">-->
    <!--                        <div class="col-8">Discount Code :</div>-->
    <!--                        <div class="col-4" style="text-align:right;height:unset;">{{item.discount_code}}</div>-->
    <!--                      </div>-->
    <!--                      <div class="row" style="width:100%;text-align:left;font-size:14px;">-->
    <!--                        <div class="col-6">Discount:</div>-->
    <!--                        <div class="col-6" style="text-align: right;">{{item.discount_qty_amount_show}} Off</div>-->
    <!--                      </div>-->
                        </div>
                      </td>
                      <td>
                        <h2>{{item.single_price_show_incl_tax}}</h2>
                      </td>
                      <td>
                        <h2 class="td-color">
                        {{item.qty}}
                        </h2>
                      </td>
                      <td>
                        <h2 class="td-color">
                          <template v-if="item.rewarditemtext">
                            {{item.rewarditemtext}}
                          </template>
                          <temlate v-else>
                            Your Unibud Reward
                          </temlate>
                        </h2>
                      </td>
                      <td>
                      </td>
                      <td>
                        <h2 class="td-color"
                        >{{ item.discounted_qty_price_show_incl_tax }}</h2>
                      </td>
                      <td>
                      </td>
                  </template>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="my-cart-foot-table">
              <table class="table cart-table cart-list-table table-responsive-xs t-foot" v-if="cart.length">
                <tfoot>
                  <tr v-for="tax in webTotalLines" :key="tax.text" >
                    <td v-if="tax.type=='taxesfees'" v-b-modal.modal-cart-detail>{{tax.text}}</td>
                    <td v-else>{{tax.type == 'delivery' ? 'Delivery Fees' : tax.type == 'subtotal' ? 'Subtotal' : tax.text}}</td>
                    <td class="text-right">
                      <div :style="tax.style=='crossed'?'text-decoration: line-through;':tax.style=='bold'?'font-weight: bold;':'font-style: normal;'">{{tax.value_show}}</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="col-sm-12 empty-cart-cls text-center" v-if="!cart.length">
            <img :src='"@/assets/images/icon-empty-cart.png"' class="img-fluid" alt="empty cart" />
            <h3 class="mt-3">
              <strong>Your Cart is Empty</strong>
            </h3>
            <div class="col-12">
              <router-link :to="{ path: '/shop'}" class="btn btn-solid">Shop</router-link>
            </div>
          </div>
        </div>
        <div class="row cart-buttons" v-if="cart.length">
          <div class="col-md-6 col-sm-6">
            {{getWarningText}}
            <template>
              <br>
              {{getFreeDeliveryText}}
            </template>
          </div>
          <div class="col-md-6 col-sm-6 text-sm-right text-center">
            <router-link v-if="!getBlockCheckout" :to="{ path: '/shop/checkout'}" :class="'btn btn-solid checkout-btn light-checkout-btn mb-0'">Checkout</router-link>
            <router-link v-else :to="{ path: '/shop'}" :class="'btn btn-solid checkout-btn light-checkout-btn mb-0'">Shop</router-link>
          </div>
        </div>
      </div>
      <b-modal
      id="modal-cart-detail"
      size="lg"
      centered
      :hide-footer="true">
        <div class="tax-fee-title">{{webTotalTitle}}</div>
        <table style="border-bottom: 1px solid #bdbdbd; margin-bottom: 15px;" align="center">
          <thead>
            <tr>
              <td class="tax-fee-header">DETAIL</td>
              <td class="tax-fee-header">DESCRIPTION</td>
              <td class="tax-fee-header">PRICE</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fee,index) in webTotalDetails" :key="index">
              <td>{{fee.text}}</td>
              <td class="tf-margin">{{fee.description}}</td>
              <td>{{fee.value_show}}</td>
            </tr>
          </tbody>
        </table>
        <strong>{{webTotalLegalText}}</strong> {{webTotalLegalUrl}}
      </b-modal>
    </section>
    <Footer />
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import Header from '@/components/header'
import Footer from '@/components/footer'
import Breadcrumbs from '@/components/widgets/cart-breadcrumbs'
export default {
  data() {
    return {
      counter: 1
    }
  },
  components: {
    Header,
    Footer,
    Breadcrumbs
  },
  computed: {
    ...mapGetters({
      signedIn: 'auth/signedIn',
      cart: 'cart/cartItems',
      cartTotal: 'cart/cartTotalAmount',
      cartTax: 'cart/taxAmount',
      getDetail: 'products/getProductByProductId',
      webTotalDetails: 'cart/webTotalDetails',
      webTotalLines:'cart/webTotalLines',
      webTotalTitle: 'cart/webTotalTitle',
      webTotalLegalText:'cart/webTotalLegalText',
      webTotalLegalUrl:'cart/webTotalLegalUrl',
      getBlockCheckout: 'cart/getBlockCheckout',
      getFreeDeliveryText: 'cart/getFreeDeliveryText',
      getIsFreeDelivery: 'cart/getIsFreeDelivery',
      getWarningText: 'cart/getWarningText',
      getLoaded: 'products/getLoaded',
      pending_delivery: 'auth/pending_delivery',
      special_banner_text: 'cart/special_banner_text',
      special_banner_url: 'cart/special_banner_url',
    })
  },
  mounted() {
    if(!this.getLoaded) {
      this.$router.push({name: 'home'})
    }
    else {
      if(this.signedIn) {
        this.$store.dispatch('auth/getPendingDeliveryStatus');
      }
    }
  },
  methods: {
    href_click_log(type) {
      this.$store.dispatch('auth/setHrefClickLog',{type: type, 'url': this.special_banner_url });
    },
    removeCartItem: function (cart) {
      this.$store.dispatch('cart/removeCartItem', cart)
    },
    increment(cart, qty = 1) {
      this.$store.dispatch('cart/updateCartQuantity', {
        cart,
        qty
      })
    },
    decrement(cart, qty = -1) {
      if(cart.qty+qty<1) return
      this.$store.dispatch('cart/updateCartQuantity', {
        cart,
        qty
      })
    },
    editqty(cart, qty = 0) {
       if(cart.qty+qty<1) return
       this.$store.dispatch('cart/updateCartQuantity', {
        cart,
        qty
      })
    }
  }
}
</script>
